import { ChainConfig, Stable } from 'core/constants'
import Web3Factory from './Web3Factory'
import { estimateGasFeeFromEnv } from 'utility/gas'
import { normalizePrice } from 'core/helpers/contract'

export default class OnChainBase extends Web3Factory {
  private gasFeeEndpoint?: string
  protected wallet?: string
  protected chainConfig!: ChainConfig
  protected currency!: {
    [currency in Stable['symbol']]: {
      contract: Contract.IERC20
    } & Stable
  }

  setChain(_web3Utils: any, chainocnfig: ChainConfig) {
    this.chainConfig = chainocnfig
  }

  setAvailableCurrencies(currencies: typeof this.currency) {
    this.currency = currencies
  }

  protected async canOperatorManageTokens(
    tokenContract: Contract.ERC1155 | Contract.ERC721,
    operator: string,
    tokenId?: number
  ) {
    if (tokenId && 'getApproved' in tokenContract.methods) {
      const operatorForThisToken = await tokenContract.methods
        .getApproved(String(tokenId))
        .call()
      return operatorForThisToken === operator
    } else {
      return await tokenContract.methods
        .isApprovedForAll(this.wallet!, operator)
        .call()
    }
  }

  protected async isAllowanceAuthorized(
    currency: string,
    _allowanceRequired: number,
    operator: string
  ) {
    const currencyInfo = this.currency[currency]
    const contract = currencyInfo.contract
    /** Checks if sales contract can movement payment token */
    const permissionedAllowanceWei = await contract.methods
      .allowance(this.wallet!, operator)
      .call()
    const permissionedAllowance = normalizePrice(
      Number(permissionedAllowanceWei),
      currencyInfo.decimals
    )

    return permissionedAllowance
  }

  setGasFeeEndpoint(endpoint: string | undefined) {
    this.gasFeeEndpoint = endpoint
  }

  protected async calculateGas() {
    if (process.env.AUTOMATION)
      return {
        gas: 90000000,
        gasPrice: '90000000000',
      }

    return {
      maxPriorityFeePerGas: await estimateGasFeeFromEnv(this.gasFeeEndpoint),
    }
  }
  setWallet(wallet: string) {
    this.wallet = wallet
  }
}
